module.exports = __webpack_public_path__ + "img/Presentation18.ea120932.png";